import { ICON_TYPE } from "components/icons/icon";
import { DateRangeSupport } from "helpers/shared/formatters/dates";

import { LD_FEATURE_FLAGS } from "types/context";
import type { ISectionProps } from "types/navigation";

const TRUST: ISectionProps = {
  feature: "Trust",
  icon: ICON_TYPE.TRUST,
  path: "/trust",
  level: ["store", "brand"],
  dateSupport: DateRangeSupport.NONE,
  subSections: [
    {
      feature: "Status Page",
      externalTarget: "https://status.breadcrumb.com/",
      level: ["store", "brand"],
      scope: ["staff", "superuser"],
      path: "",
      legacyPath: () => "https://status.breadcrumb.com/",
      dateSupport: DateRangeSupport.NONE,
    },
    {
      feature: "Refer & Earn",
      externalTarget: "https://www.lightspeedhq.com/referral-program/",
      level: ["store", "brand"],
      scope: ["staff", "superuser"],
      path: "",
      legacyPath: () => "https://www.lightspeedhq.com/referral-program/",
      dateSupport: DateRangeSupport.NONE,
      requiresFeatureFlag: LD_FEATURE_FLAGS.hq3ReferAndEarn,
    },
    {
      feature: "Help",
      externalTarget: "https://help.upserve.com/",
      level: ["store", "brand"],
      scope: ["staff", "superuser"],
      path: "",
      legacyPath: () => "https://help.upserve.com/",
      dateSupport: DateRangeSupport.NONE,
    },
    {
      feature: "Integration Partners",
      contentUrl: "https://upserve.com/marketplace/technology-partners/",
      level: ["store", "brand"],
      scope: ["staff", "superuser"],
      path: "/trust/integration-partners",
      dateSupport: DateRangeSupport.NONE,
      requiresFeatureFlag: LD_FEATURE_FLAGS.hqUiIntegrationPartners,
    },
    // TODO: fix toggleChatVisibility and start with chat button hidden
    /*
      {
        feature: "Chat",
        app: null,
        navFunction: toggleChatVisibility,
        level: ["store", "brand"],
        scope: ["staff", "superuser"],
        // Functionality on this item TBD - creating fake route so it won't be highlighted all the time
        path: "/trust/chat",
        legacyPath: () => "",
        dateSupport: DateRangeSupport.NONE,
      },
      */
  ],
};

export default TRUST;
